import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type UpdateQuoteRequestLineQuantity = ClientInferResponseBody<
  typeof contract.quoteRequestLines.updateQuantity
>;

export type UpdateQuoteRequestLineQuantityDto = ClientInferRequest<
  typeof contract.quoteRequestLines.updateQuantity
>["body"];

export const updateQuoteRequestLineQuantity = async ({
  id,
  payload,
}: {
  id: string;
  payload: UpdateQuoteRequestLineQuantityDto;
}): Promise<UpdateQuoteRequestLineQuantity> => {
  const response = await api.quoteRequestLines.updateQuantity.mutation({
    params: {
      id,
    },
    body: payload,
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError("Failed to update quantity", response.status, response.body);
};
